import React, {useState } from 'react'
import { Button, Card, Col, Modal, Row } from 'react-bootstrap'
import CreditCard from '../components/CreditCard'

function BuyCredits() {

    const [ showModal, setShowModal ] = useState(false)
    const [ amount, setAmount ] = useState(0)
    const [ store, setStore ] = useState(false)

    const handleSubmit = (amount, store) => {
        setAmount(amount)
        setStore(store)
        setShowModal(true)
    }

  return (
    <div>
        <h2>Buy Listing Credits</h2>
        <Row>
            <Col md={3}>
                <Card className='rounded-3'>
                    <Card.Header>Try-it-out</Card.Header>
                    <Card.Text className='card-text' style={{ height: 140 }}>
                        $5 for 5 listings. For the price of a cup of coffee, create 5 listings, and discover how it can help you create better listings.
                        You can buy this package only once.
                    </Card.Text>
                    <Card.Footer>Price: $5 for 5 listings</Card.Footer>
                    <Button className='rounded-bottom-3' type='submit' onClick={() => handleSubmit(5, false)} onSubmit={handleSubmit}>Buy</Button>
                </Card>
            </Col>

            <Col md={3}>
                <Card className='rounded-3'>
                    <Card.Header>Pay as you go</Card.Header>
                    <Card.Text className='card-text' style={{ height: 140 }}>
                        Enter your credit card number, and we'll charge you automatically for every listing you create.
                    </Card.Text>
                    <Card.Footer>Price: $5 per listing</Card.Footer>
                    <Button className='rounded-bottom-3' type='submit' onClick={() => handleSubmit(0, true)} onSubmit={handleSubmit}>Buy</Button>
                </Card>
            </Col>

            <Col md={3}>
                <Card className='rounded-3'>
                    <Card.Header>10 Credits</Card.Header>
                    <Card.Text className='card-text' style={{ height: 140 }}>
                        Buy 10 listings credits, and get one listing for free!
                    </Card.Text>
                    <Card.Footer>Price: $50 for 11 listings</Card.Footer>
                    <Button className='rounded-bottom-3' type='submit' onClick={() => handleSubmit(50, false)}>Buy</Button>
                </Card>
            </Col>

            <Col md={3}>
                <Card className='rounded-3'>
                    <Card.Header>20 Credits</Card.Header>
                    <Card.Text className='card-text' style={{ height: 140 }}>
                        Buy 20 listing credits, and get 4 listings for free!                        
                    </Card.Text>
                    <Card.Footer>Price: $100 for 24 listings</Card.Footer>
                    <Button className='rounded-bottom-3' type='submit' onClick={() => handleSubmit(100, false)}>Buy</Button>
                </Card>
            </Col>
        </Row>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton><h4>Enter payment information</h4></Modal.Header>
            <Modal.Body><CreditCard amount={amount} force={store}/></Modal.Body>
        </Modal>
    </div>
  )
}

export default BuyCredits